export const UserType = {
  DIRECT_MANAGER: 'direct_manager',
  SUPER_MANAGER: 'super_manager',
} as const;

export type UserType = (typeof UserType)[keyof typeof UserType];
